import * as React from "react";
import { Helmet } from "@lonelyplanet/travel-agent/dist/helmet";
var BaseMeta = function (_a) {
    var meta = _a.meta, poi = _a.poi, nearbyPois = _a.nearbyPois;
    return (React.createElement(Helmet, null,
        React.createElement("title", null, meta.title),
        React.createElement("meta", { name: "title", content: meta.title }),
        React.createElement("meta", { name: "description", content: meta.description.truncated }),
        React.createElement("meta", { property: "og:title", content: meta.title }),
        React.createElement("meta", { property: "og:description", content: meta.description.truncated }),
        React.createElement("meta", { className: "swiftype", name: "title", "data-type": "string", content: meta.title }),
        React.createElement("meta", { className: "swiftype", name: "body", "data-type": "text", content: meta.description.full }),
        React.createElement("meta", { className: "swiftype", name: "op-id", "data-type": "string", content: poi.id }),
        React.createElement("meta", { className: "swiftype", name: "op-type", "data-type": "string", content: poi.type }),
        poi.alternative_names && (poi.alternative_names.map(function (alternativeName) {
            return (React.createElement("meta", { key: alternativeName, className: "swiftype", name: "op-alternatives", "data-type": "string", content: alternativeName }));
        })),
        React.createElement("link", { rel: "canonical", href: meta.canonical }),
        nearbyPois &&
            nearbyPois.mapMarkers && (React.createElement("link", { rel: "stylesheet", href: "https://unpkg.com/leaflet@1.3.1/dist/leaflet.css", type: "text/css" }))));
};
export default BaseMeta;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/baseMeta/index.tsx
// module id = Kbyn
// module chunks = 2